import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Search, Plus, Download, Inbox } from 'lucide-react';

import cs from '../../components/commonStyle.css';
import s from './CommonTable.css';
import Link from '../../components/Link';
import messages from '../../locale/messages';

class CommonTable extends React.Component {
    render() {
        const { thead, tbody, title, onSearch, isSearch, isLink, isExport, exportLink, redirectionLabel, href, addAction, className, isHeadingHide } = this.props;
        const { formatMessage } = this.props.intl;
        const theadData = thead();
        const tbodyData = tbody();
        
        return (
            <div className={cx(s.tableContainer, className)}>
                {/* Table Header with Title, Search and Actions */}
                <div className={s.tableHeader}>
                    {!isHeadingHide && <h2 className={s.tableTitle}>{title}</h2>}
                    
                    <div className={s.tableActions}>
                        {/* Search Input */}
                        {isSearch && (
                            <div className={s.searchWrapper}>
                                <Search size={18} className={s.searchIcon} />
                                <input
                                    type="text"
                                    placeholder={formatMessage(messages.search)}
                                    onChange={(e) => onSearch(e)}
                                    className={s.searchInput}
                                />
                            </div>
                        )}
                        
                        {/* Add Button */}
                        {isLink && href && (
                            <Link to={href} className={cx(s.actionBtn, s.actionBtnPrimary)}>
                                <Plus size={18} />
                                {redirectionLabel}
                            </Link>
                        )}
                        
                        {/* Add Action Button */}
                        {isLink && addAction && (
                            <button onClick={addAction} className={cx(s.actionBtn, s.actionBtnPrimary)}>
                                <Plus size={18} />
                                {redirectionLabel}
                            </button>
                        )}
                        
                        {/* Export Button */}
                        {tbodyData?.length > 0 && isExport && (
                            <a href={exportLink} className={s.actionBtn}>
                                <Download size={18} />
                                <FormattedMessage {...messages.exportDataIntoCSV} />
                            </a>
                        )}
                    </div>
                </div>
                
                {/* Table Content */}
                <div className={s.tableWrapper}>
                    <table className={s.table}>
                        <thead>
                            <tr>
                                {theadData?.map((item, index) => (
                                    <th scope="col" key={index}>{item.data}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tbodyData && tbodyData.length > 0 ? (
                                tbodyData.map((item, index) => (
                                    <tr key={item.id || index}>
                                        {item.data.map((value, idx) => (
                                            <td data-label={theadData[idx]?.data} key={idx}>
                                                {value.data}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={theadData?.length}>
                                        <div className={s.emptyState}>
                                            <Inbox size={48} className={s.emptyStateIcon} />
                                            <p className={s.emptyStateText}>
                                                <FormattedMessage {...messages.noRecordFound} />
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default injectIntl(withStyles(s, cs)(CommonTable));